export const PAGE_SURFACE = "bg-transparent lg:bg-layout";
